
// custom

// Open and handle Size Chart, Face Guide, and Prescription modals
window.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const sizeChartModal = document.querySelector('.size-modal');
  const faceChartModal = document.querySelector('.face-modal');
  const sizeChartDialog = document.querySelector('.size_chart_modal');
  const sideOption = document.querySelector('.side_option');
  const chooseLenses = document.querySelector('.choose-lenses');
  const prescriptionContainer = document.querySelector('.prescription');
  const backButton = prescriptionContainer?.querySelector('.back');
  const closeBtns = document.querySelectorAll('.close, .custom-close-btn, [data-dismiss="modal"]');

  // Helper to open Size Chart
  function openSizeChart(e) {
    if (e) e.preventDefault();
    if (sizeChartDialog) {
      sizeChartDialog.style.display = ''; // Clear any inline display override
      if (typeof sizeChartDialog.showModal === 'function') {
        if (!sizeChartDialog.open) {
          try {
            sizeChartDialog.showModal();
          } catch (err) {
            sizeChartDialog.style.display = 'block';
          }
        }
      } else {
        sizeChartDialog.style.display = 'block';
      }
    } else if (sizeChartModal) {
      sizeChartModal.style.display = 'block';
    }
    body.style.overflow = 'hidden';
  }

  // Helper to open Face Shape Guide Modal
  function openFaceModal(e) {
    if (e) e.preventDefault();
    // alert("checking");
    if (faceChartModal) {
      faceChartModal.style.display = 'block';
      body.style.overflow = 'hidden';
    }
  }

  // Helper to close all modals and dialogs
  function closeAllModals() {
    if (faceChartModal) faceChartModal.style.display = 'none';
    if (sizeChartModal) sizeChartModal.style.display = 'none';
    if (sizeChartDialog) {
      if (typeof sizeChartDialog.close === 'function' && sizeChartDialog.open) {
        sizeChartDialog.close();
      }
      sizeChartDialog.style.display = ''; // Do NOT set 'none', clear inline style so showModal works next time
    }
    if (sideOption) {
      sideOption.style.visibility = 'hidden';
      sideOption.style.opacity = '0';
    }
    body.style.overflow = 'auto';
  }

  // 1. Size Chart triggers (Top button: #ff-size-chart, .first-fold-size-chart, or data-target)
  document.querySelectorAll('#ff-size-chart, .first-fold-size-chart, [data-target="#exampleModalRight"]').forEach((el) => {
    el.addEventListener('click', openSizeChart);
  });

  // 2. Table Specs triggers (.size-chart)
  const sizeChartToggles = document.querySelectorAll('.size-chart');
  if (sizeChartToggles.length > 0) {
    // 1st .size-chart link -> Size Chart
    sizeChartToggles[0].addEventListener('click', openSizeChart);
  }
  if (sizeChartToggles.length > 1) {
    // 2nd .size-chart link -> Face Shape Guide
    sizeChartToggles[1].addEventListener('click', openFaceModal);
  }

  // Face Guide trigger via data-target if present
  document.querySelectorAll('[data-target="#exampleModalLeft"]').forEach((el) => {
    el.addEventListener('click', openFaceModal);
  });

  // 3. Choose lenses toggle
  if (chooseLenses) {
    chooseLenses.addEventListener('click', (event) => {
      event.preventDefault();
      if (sideOption) {
        sideOption.style.visibility = 'visible';
        sideOption.style.opacity = '1';
      }
      body.style.overflow = 'hidden';
    });
  }

  // 4. Back button in prescription
  if (backButton) {
    backButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (sideOption) {
        sideOption.style.visibility = 'hidden';
        sideOption.style.opacity = '0';
      }
      body.style.overflow = 'auto';
    });
  }

  // 5. Close buttons click handler
  closeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      closeAllModals();
    });
  });

  // 6. Outside click handler for modal divs (Face Modal & Size Modal)
  window.addEventListener('click', (event) => {
    if (event.target === faceChartModal || event.target === sizeChartModal) {
      closeAllModals();
    }
  });

  // 7. Outside click & ESC key handlers for native <dialog>
  if (sizeChartDialog) {
    sizeChartDialog.addEventListener('click', (event) => {
      const rect = sizeChartDialog.getBoundingClientRect();
      const isInDialog =
        rect.top <= event.clientY &&
        event.clientY <= rect.top + rect.height &&
        rect.left <= event.clientX &&
        event.clientX <= rect.left + rect.width;
      if (!isInDialog) {
        closeAllModals();
      }
    });

    // Automatically restore body scrolling if dialog is closed via ESC key or form submit
    sizeChartDialog.addEventListener('close', () => {
      body.style.overflow = 'auto';
    });
  }
});